import {
  Component,
  ViewChild,
  Injector,
  NgModule,
  ViewEncapsulation
} from '@angular/core';

import {
  MdSidenav
} from '@angular/material';

import { AuthGuardService } from '../../services';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';

export const DEFAULT_INPUTS_O_SIDE_MENU = [
  // title [string]: menu title. Default: no value.
  'title'
];


export class OSideMenuComponent {

  public static DEFAULT_INPUTS_O_SIDE_MENU = DEFAULT_INPUTS_O_SIDE_MENU;

  protected authGuardService: AuthGuardService;

  protected _title: string;
  protected _opened: boolean;

  
  protected sidenav: MdSidenav;

  constructor(protected injector: Injector) {
    this.opened = false;
    this.authGuardService = this.injector.get(AuthGuardService);
  }

  public showSidenav() {
    this.opened = true;
    this.sidenav.open();
    this.sidenav.onClose.subscribe(res => {
      this.opened = false;
    });
  }

  getAuthGuardService() : AuthGuardService {
    return this.authGuardService;
  }

  get title(): string {
    return this._title;
  }

  set title(val : string) {
    this._title = val;
  }

  get opened(): boolean {
    return this._opened;
  }

  set opened(val : boolean) {
    this._opened = val;
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-side-menu',
  template: `
    <md-toolbar color="primary">
      <div md-ripple layout-padding fxLayout="row" fxLayoutAlign="space-between stretch" class="o-side-menu-icon-open" (click)="showSidenav()">
        <md-icon class="mat-24">menu</md-icon>
      </div>
    </md-toolbar>

    <md-sidenav-container [class.menu-opened]="opened">
      <md-sidenav #sidenav>
        <h3>
          <span>{{ title | oTranslate }}</span>
        </h3>
        <md-nav-list>
          <ng-content></ng-content>
        </md-nav-list>
      </md-sidenav>
    </md-sidenav-container>
  `,
  styles: [`
    o-side-menu .o-side-menu-icon-open{cursor:pointer}o-side-menu md-sidenav-container.menu-opened{position:fixed;top:0;left:0;right:0;bottom:0;z-index:1001}o-side-menu md-nav-list.mat-nav-list{padding-top:0px}o-side-menu h3{padding:25px;border-bottom:3px solid;margin:0px}@media all and (min-width: 768px){o-side-menu md-sidenav{width:250px}}@media all and (max-width: 767px){o-side-menu md-sidenav{width:250px}}@media all and (max-width: 330px){o-side-menu md-sidenav{width:96%}}.mat-input-placeholder{z-index:1000}
  `],
  inputs: [
    ...DEFAULT_INPUTS_O_SIDE_MENU
  ],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'sidenav': [{ type: ViewChild, args: ['sidenav', ] },],
};
}


export class OSideMenuModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [
    OSideMenuComponent
  ],
  imports: [
    OSharedModule,
    CommonModule
  ],
  exports: [
    OSideMenuComponent
  ]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
